import React, { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import InfoIcon from '@mui/icons-material/Info';
import { uploadAssets, getCostCenterByCompany } from '../../../services/asset.service';
import { getDepartmentList } from '../../../services/user.service';
import { getInvoiceCurrencyList, getTypeOfAdditionList, getYearOfAdditionList, getUnitOfMeasureList } from '../../../services/master.service';
import './AssetInfo.css';
import * as CryptoJS from "crypto-js";

const parent_templatePath = "/exceltemplates/Parent_Asset_Addition_Template.xlsx";
const child_templatePath = "/exceltemplates/Child_Asset_Addition_Template.xlsx";
const download_img_Url = "/new-download.gif";

const year_of_addition_columns = [
  { "field": "year_of_addition", "editable": false, "hide": false, "headerName": "Year Of Addition Name", "width": 564 },
];
const type_of_addition_columns = [
  { "field": "additions_type_name", "editable": false, "hide": false, "headerName": "Addition Type Name", "width": 564 },
];
const invoice_currency_columns = [
  { "field": "currency_type_name", "editable": false, "hide": false, "headerName": "Invoice Currency", "width": 564 },
];
const control_department_columns = [
  { "field": "department_name", "editable": false, "hide": false, "headerName": "Control Department Name", "width": 564 },
];
const Cost_Center_Columns = [
  { "field": "cost_center_code", "editable": false, "hide": false, "headerName": "Cost Center Code", "width": 564 },
];
const Unit_of_Measurement_Columns = [
  { "field": "tag_unit_of_measure_name", "editable": false, "hide": false, "headerName": "Unit of Measurement", "width": 564 },
];

export default function AssetInfo() {
  const errRef = useRef();
  const [validName, setValidName] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [year_of_addition_items, setYear_of_Addition_Items] = useState([]);
  const [type_of_addition_items, setType_of_Addition_Items] = useState([]);
  const [invoice_currency_items, setInvoice_Currency_Items] = useState([]);
  const [control_department_items, setControl_Department_Items] = useState([]);
  const [Cost_Center_Items, setCost_Center_Items] = useState([]);
  const [Unit_of_Measurement, setUnit_of_Measurement] = useState([]);

  useEffect(() => {
    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
      'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    let oData = { 'token': EncryptData }
    
    getYearOfAdditionList(oData).then(res => {
      if (res?.data?.data?.length) setYear_of_Addition_Items(res.data.data);
    });
    getTypeOfAdditionList(oData).then(res => {
      if (res?.data?.data?.length) setType_of_Addition_Items(res.data.data);
    });
    getInvoiceCurrencyList(oData).then(res => {
      if (res?.data?.data?.length) setInvoice_Currency_Items(res.data.data);
    });
    getDepartmentList(oData).then(res => {
      if (res?.data?.data?.length) setControl_Department_Items(res.data.data);
    });
    getCostCenterByCompany(oData).then(res => {
      if (res?.data?.data?.length) setCost_Center_Items(res.data.data);
    });
    getUnitOfMeasureList(oData).then(res => {
      if (res?.data?.data?.length) setUnit_of_Measurement(res.data.data);
    });
  }, [])

  const onChangeFile = async (event) => {
    event.preventDefault();
    if (event.target.files[0]?.name.split('.').pop() == 'undefined' || event.target.files[0]?.name.split('.').pop() !== 'xlsx') {
      setErrMsg("Please upload valid format. Excel file only allowed.");
      return false;
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append('file', event.target.files[0]);
        formData.append('company_id', sessionStorage.getItem('LoggedInCompanyId'));
        formData.append('division_id', sessionStorage.getItem('LoggedInDivisionId'));
        formData.append('created_by', sessionStorage.getItem('LoggedInUserId'));
        formData.append('division_code', sessionStorage.getItem('LoggedInDivisionCode'));
        formData.append('child_asset', 'no');

        uploadAssets(formData).then(res => {
          if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
            setErrMsg(res.data.message);
            setLoading(false);
            setSuccess(false);
          } else {
            setSuccess(res.data.message);
            setLoading(false);
          }
        })
      } catch (error) {
        setLoading(false);
        console.error(error);
        setErrMsg(error.data.message);
      }
    }
  };

  const onChangeFile1 = async (event) => {
    event.preventDefault();
    if (event.target.files[0]?.name.split('.').pop() == 'undefined' || event.target.files[0]?.name.split('.').pop() !== 'xlsx') {
      setErrMsg("Please upload valid format. Excel file only allowed.");
      return false;
    } else {
      const data = new FormData()
      data.append('file', event.target.files[0]);
      try {
        setLoading1(true);
        data.append('company_id', sessionStorage.getItem('LoggedInCompanyId'));
        data.append('division_id', sessionStorage.getItem('LoggedInDivisionId'));
        data.append('created_by', sessionStorage.getItem('LoggedInUserId'));
        data.append('division_code', sessionStorage.getItem('LoggedInDivisionCode'));
        data.append('child_asset', 'yes');
        
        uploadAssets(data).then(res => {
          if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
            setErrMsg(res.data.message);
            setLoading1(false);
            setSuccess(false);
          } else {
            setSuccess(res.data.message);
            setLoading1(false);
          }
        });

      } catch (error) {
        setLoading1(false);
        console.error(error);
        setErrMsg(error.data.message);
      }
    }
  };

  return (
    <div className='asset-info-container'>
      {/* Loading Overlay */}
      {(loading || loading1) && (
        <div className="loading-overlay">
          <div className="loading-card">
            <div className="loading-spinner">
              <img src={download_img_Url} alt="Loading" />
            </div>
            <h5 className="loading-title">Uploading Assets...</h5>
            <p className="loading-subtitle">
              <InfoIcon fontSize="small" /> Please don't refresh the page
            </p>
          </div>
        </div>
      )}

      {/* Header Section */}
      <div className='page-header'>
        <div className='header-content'>
          <div className='header-left'>
            <div className='header-icon'>
              <CloudUploadIcon style={{ fontSize: '2rem' }} />
            </div>
            <div>
              <h5 className='page-title'>Bulk Asset Addition</h5>
              <p className='page-subtitle'>Upload multiple assets using Excel templates</p>
            </div>
          </div>
          <div className='header-right'>
            <a href={'/asset-list'} className="btn-outline-primary">
              <i className='bi bi-list'></i> Asset List
            </a>
          </div>
        </div>

        {/* Alert Messages */}
        {success && (
          <div className="alert-success-modern">
            <i className="bi bi-check-circle-fill"></i>
            <span>{success}</span>
          </div>
        )}
        {errMsg && (
          <div className="alert-danger-modern">
            <i className="bi bi-exclamation-triangle-fill"></i>
            <span>{errMsg}</span>
          </div>
        )}
      </div>

      {/* Upload Cards Section */}
      <div className='upload-cards-grid'>
        {/* Parent Asset Upload Card */}
        <div className='upload-card parent-card'>
          <div className='card-header'>
            <div className='card-icon parent-icon'>
              <i className='bi bi-file-earmark-arrow-up'></i>
            </div>
            <div className='card-header-text'>
              <h5>Parent Asset Addition</h5>
              <p>Upload parent asset details via Excel</p>
            </div>
          </div>
          
          <div className='card-body'>
            <div className='upload-area'>
              <Button 
                variant='contained' 
                component='label' 
                startIcon={<CloudUploadIcon />}
                className='upload-button'
                disabled={loading}
              >
                {loading ? 'Uploading...' : 'Upload Parent Assets'}
                <input hidden type='file' onChange={onChangeFile} accept=".xlsx" />
              </Button>
            </div>
            
            <div className='template-download'>
              <a href={parent_templatePath} className="download-link">
                <DownloadIcon fontSize="small" />
                Download Parent Template
              </a>
            </div>
          </div>
        </div>

        {/* Child Asset Upload Card */}
        <div className='upload-card child-card'>
          <div className='card-header'>
            <div className='card-icon child-icon'>
              <i className='bi bi-file-earmark-plus'></i>
            </div>
            <div className='card-header-text'>
              <h5>Child Asset Addition</h5>
              <p>Upload child asset details via Excel</p>
            </div>
          </div>
          
          <div className='card-body'>
            <div className='upload-area'>
              <Button 
                variant='contained' 
                component='label' 
                startIcon={<CloudUploadIcon />}
                className='upload-button'
                disabled={loading1}
              >
                {loading1 ? 'Uploading...' : 'Upload Child Assets'}
                <input hidden type='file' onChange={onChangeFile1} accept=".xlsx" />
              </Button>
            </div>
            
            <div className='template-download'>
              <a href={child_templatePath} className="download-link">
                <DownloadIcon fontSize="small" />
                Download Child Template
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Instructions Section */}
      <div className='instructions-section'>
        <div className='instructions-header'>
          <InfoIcon style={{ fontSize: '1.5rem', color: '#0084ff' }} />
          <h5>Instructions for Bulk Upload</h5>
        </div>
        
        <div className='instructions-grid'>
          <div className='instruction-item'>
            <div className='instruction-number'>1</div>
            <div className='instruction-content'>
              <strong>Date Format:</strong> Always use <code>YYYY-MM-DD</code> format for dates
            </div>
          </div>
          
          <div className='instruction-item'>
            <div className='instruction-number'>2</div>
            <div className='instruction-content'>
              <strong>Empty Cells:</strong> Use <code>NA</code> for text and <code>0</code> for numbers
            </div>
          </div>
          
          <div className='instruction-item'>
            <div className='instruction-number'>3</div>
            <div className='instruction-content'>
              <strong>Company Name:</strong> Use <code>{sessionStorage.getItem("LoggedInCompanyName")}</code>
            </div>
          </div>
          
          <div className='instruction-item'>
            <div className='instruction-number'>4</div>
            <div className='instruction-content'>
              <strong>Branch Name:</strong> Use <code>{sessionStorage.getItem("LoggedInDivisionName")}</code>
            </div>
          </div>
          
          <div className='instruction-item'>
            <div className='instruction-number'>5</div>
            <div className='instruction-content'>
              <strong>TAG Branch:</strong> Use <code>{sessionStorage.getItem('LoggedInDivisionShortName')}</code>
            </div>
          </div>
          
          <div className='instruction-item'>
            <div className='instruction-number'>6</div>
            <div className='instruction-content'>
              <strong>Prerequisites:</strong> Parent assets must be added before child assets
            </div>
          </div>
        </div>
      </div>

      {/* Reference Data Section */}
      <div className='reference-section'>
        <h5 className='reference-title'>
          <i className='bi bi-table'></i> Dropdown Reference Values
        </h5>
        <p className='reference-subtitle'>Use these values for dropdown fields in the Excel template</p>
        
        <div className='data-grid-container'>
          {/* Year of Addition */}
          <div className='grid-card'>
            <div className='grid-header'>
              <h5>Year of Addition</h5>
            </div>
            <DataGrid
              rows={year_of_addition_items}
              getRowId={(row) => row.id}
              columns={year_of_addition_columns}
              pageSize={5}
              autoHeight
              rowsPerPageOptions={[5]}
              className='custom-datagrid'
            />
          </div>

          {/* Type of Addition */}
          <div className='grid-card'>
            <div className='grid-header'>
              <h5>Type of Addition</h5>
            </div>
            <DataGrid
              rows={type_of_addition_items}
              getRowId={(row) => row.id}
              columns={type_of_addition_columns}
              pageSize={5}
              autoHeight
              rowsPerPageOptions={[5]}
              className='custom-datagrid'
            />
          </div>

          {/* Invoice Currency */}
          <div className='grid-card'>
            <div className='grid-header'>
              <h5>Invoice Currency</h5>
            </div>
            <DataGrid
              rows={invoice_currency_items}
              getRowId={(row) => row.id}
              columns={invoice_currency_columns}
              pageSize={5}
              autoHeight
              rowsPerPageOptions={[5]}
              className='custom-datagrid'
            />
          </div>

          {/* Control Department */}
          <div className='grid-card'>
            <div className='grid-header'>
              <h5>Control Department</h5>
            </div>
            <DataGrid
              rows={control_department_items}
              getRowId={(row) => row.id}
              columns={control_department_columns}
              pageSize={5}
              autoHeight
              rowsPerPageOptions={[5]}
              className='custom-datagrid'
            />
          </div>

          {/* Cost Center Code */}
          <div className='grid-card'>
            <div className='grid-header'>
              <h5>Cost Center Code</h5>
            </div>
            <DataGrid
              rows={Cost_Center_Items}
              getRowId={(row) => row.id}
              columns={Cost_Center_Columns}
              pageSize={5}
              autoHeight
              rowsPerPageOptions={[5]}
              className='custom-datagrid'
            />
          </div>

          {/* Unit of Measurement */}
          <div className='grid-card'>
            <div className='grid-header'>
              <h5>Unit of Measurement</h5>
            </div>
            <DataGrid
              rows={Unit_of_Measurement}
              getRowId={(row) => row.id}
              columns={Unit_of_Measurement_Columns}
              pageSize={5}
              autoHeight
              rowsPerPageOptions={[5]}
              className='custom-datagrid'
            />
          </div>
        </div>
      </div>
    </div>
  )
}